module.exports = __webpack_public_path__ + "img/9.6f9b0c0e.jpg";